import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/firebase-storage';

var config = {
    apiKey: "AIzaSyDhxuDgP37u6oQHw7bUvDSXl_j6Fvsu8i4",
    authDomain: "beanage-hn.firebaseapp.com",
    projectId: "beanage-hn",
    storageBucket: "beanage-hn.appspot.com",
    messagingSenderId: "347213272084",
    appId: "1:347213272084:web:dcd60975ecd64670908301"
  };

firebase.initializeApp(config);
firebase.auth().languageCode = "es";

export const db = firebase.firestore();
export const fb = firebase;